import { Box, InfoOutlinedIcon, Theme, Tooltip, Typography, useTheme } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

export const testIds = {
  customerLogin: 'top-bar-customer-login',
  demoMode: 'top-bar-demo-mode',
}

const getStyles = (theme: Theme) => ({
  specialMode: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    borderRadius: 24,
    margin: theme.spacing(0, 1),
    padding: theme.spacing(0, 1.5),
    height: '20px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  demoIndicator: {
    width: 'auto',
    backgroundColor: theme.palette.status.warning,
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      top: theme.spacing(6),
      left: 0,
      right: 0,
      borderRadius: '0 0 24px 24px',
      margin: 0,
      opacity: 0.8,
      justifyContent: 'center',
    },
  },
  demoInfoIcon: {
    height: 14,
    width: 14,
    marginLeft: theme.spacing(0.5),
  },
  customerLoginIndicator: {
    backgroundColor: theme.palette.secondary.main,
  },
  hiddenOnMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  tooltip: {
    fontSize: theme.typography.caption.fontSize,
  },
})

interface TopBarIndicatorProps {
  isDemo: boolean
  loggedInAsCustomer: boolean
}

export const TopBarIndicator: FC<TopBarIndicatorProps> = ({ isDemo, loggedInAsCustomer }) => {
  const { translate } = useI18n()
  const styles = getStyles(useTheme())

  if (isDemo) {
    return (
      <Typography
        variant="caption"
        sx={{ ...styles.specialMode, ...styles.demoIndicator }}
        data-testid={testIds.demoMode}
      >
        <Box component="span" pt="1px">
          {translate('header-demo-mode')}
        </Box>
        <Tooltip title={translate('demo-user-description')} sx={styles.tooltip}>
          <InfoOutlinedIcon sx={styles.demoInfoIcon} />
        </Tooltip>
      </Typography>
    )
  }

  if (loggedInAsCustomer) {
    return (
      <Typography
        variant="caption"
        sx={{ ...styles.specialMode, ...styles.customerLoginIndicator, ...styles.hiddenOnMobile, pt: '1px' }}
        data-testid={testIds.customerLogin}
      >
        {translate('logged-in-as-customer-text')}
      </Typography>
    )
  }

  return null
}
